import { useRouter } from "next/router";
import { useEffect } from "react";

import { useSetProfileData }           from "_common/hooks/auth";
import { useSetLoggedIn }              from "_common/hooks/auth";
import { useGetLoggedIn }              from "_common/hooks/auth";
import { useSetUserOnBoardingAborted } from "_common/hooks/global";
import { initialValidations }          from "_common/ssrWrapper";
import { clearUserData }               from "_common/utils/user";
import { logoutUser }                  from "_components/pages/auth/apis";

const component = () => {
	const router                   = useRouter ();
	const setProfile               = useSetProfileData ();
	const setLoggedIn              = useSetLoggedIn ();
	const isLoggedIn               = useGetLoggedIn ();
	const setUserOnBoardingAborted = useSetUserOnBoardingAborted ();

	const init = async () => {
		clearUserData ();

		const qParams    = router.query;
		let forceLogout  = true;
		let prevLocation = "/";

		if ( qParams ) {
			// forceLogout  = qParams.forceLogout || !isLoggedIn || false;
			prevLocation = qParams.prevLocation || "/";

			if ( prevLocation === "/logout" )
				prevLocation = "/";
		}

		await logoutUser ( { forceLogout } );

		if ( isLoggedIn ) {
			setUserOnBoardingAborted ( false );
			setProfile ( undefined );
			setLoggedIn ( false );
		}

		window.location.replace ( prevLocation );
	};

	useEffect ( () => {
		if ( !router.isReady )
			return;

		init ();
	}, [ router.isReady ] );

	return (
		<div
			style = { {
				minHeight      : "calc(100vh - 104px)",
				display        : "flex",
				justifyContent : "center",
				alignItems     : "center",
				color          : "white"
			} }
		>
			Your session expired, reloading...
		</div>
	);
};

export default component;

const getServerSideProps = async context => initialValidations ( context, async defaultProps => {
	/* context.res.setHeader (
    "Cache-Control",
    "public, s-maxage=120, stale-while-revalidate=600"
  ); */

	return {
		props: {
			...defaultProps,
			noAuth      : true,
			noLayout    : true,
			noAnalytics : true
		}
	};
} );

export { getServerSideProps };
